import { useEffect, RefObject } from 'react'
import * as echarts from 'echarts'

interface UseChartResizeParams {
  chartRefs: RefObject<HTMLDivElement>[]
}

/**
 * Hook to handle window resize events for all charts
 * Automatically resizes all chart instances when the window is resized
 */
export const useChartResize = ({ chartRefs }: UseChartResizeParams) => {
  useEffect(() => {
    const handleResize = () => {
      chartRefs.forEach((chartRef) => {
        if (chartRef.current && echarts.getInstanceByDom(chartRef.current)) {
          echarts.getInstanceByDom(chartRef.current)?.resize()
        }
      })
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [chartRefs])
}
